"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fonte": {
    "47e27a32": [{
      "hkey": "4b518e51",
      "slug": "one-di-fonte",
      "name": "Onè di Fonte",
      "primary": true,
      "skipSearch": false
    }],
    "one": [{
      "hkey": "4b518e51",
      "slug": "one-di-fonte",
      "name": "Onè di Fonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fonte"
    }]
  }
};
exports["default"] = _default;